import { RequestError, isRequestError } from "./errors";
import { getClientDependencies } from "./state";
import { buildURL } from "./url";
const ASSISTANT_ENV_HEADER = "X-Poolside-Assistant-Environment";
const ASSISTANT_HOST_HEADER = "X-Poolside-Assistant-Host";
const ASSISTANT_HOST_VERSION_HEADER = "X-Poolside-Assistant-Host-Version";
const ASSISTANT_VERSION_HEADER = "X-Poolside-Assistant-Version";
// lookup from global to allow for mocking
let fetcher = (url, opts) => fetch(url, opts);
let onApiError;
export function setApiErrorCallback(callback) {
    onApiError = callback;
}
export function setFetch(f) {
    fetcher = f;
}
export function getFetch() {
    return fetcher;
}
export const fetchClient = async ({ url, method, 
// params are sent via query params
params, 
// data is the request body
data, headers, signal, responseType, }) => {
    const { environment, userSettings: { uri: baseURI }, } = await getClientDependencies();
    if (!baseURI) {
        throw new Error("API URI is not configured");
    }
    const opts = { method, headers: { ...headers }, signal };
    let assistantHostHeader = `${environment.assistantHost}`;
    if (environment.assistantProduct) {
        assistantHostHeader = `${environment.assistantHost}:${environment.assistantProduct.toLowerCase().replace(/\W/g, "-")}`;
    }
    const defaultHeaders = await getDefaultAPIHeaders();
    opts.headers = {
        ...headers,
        ...defaultHeaders,
        [ASSISTANT_HOST_HEADER]: assistantHostHeader,
    };
    if (data) {
        if (data instanceof FormData) {
            opts.body = data;
            delete opts.headers["Content-Type"];
        }
        else if (data instanceof Blob) {
            opts.body = data;
        }
        else {
            opts.body = JSON.stringify(data);
        }
    }
    const fullUrl = buildURL(baseURI, url, params).toString();
    try {
        return await handleApiResponse(await fetcher(fullUrl, opts), responseType);
    }
    catch (error) {
        if (onApiError && isRequestError(error)) {
            onApiError(error, fullUrl);
        }
        throw error;
    }
};
export async function getDefaultAPIHeaders() {
    const { accessToken, environment } = await getClientDependencies();
    return Object.fromEntries(Object.entries({
        [ASSISTANT_ENV_HEADER]: environment.assistantEnv,
        [ASSISTANT_HOST_VERSION_HEADER]: environment.assistantHostVersion,
        [ASSISTANT_VERSION_HEADER]: environment.assistantVersion,
        // include access token if we're authenticated
        ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
    }).filter(([_, value]) => value != null && value !== ""));
}
export async function handleApiResponse(response, responseType) {
    if (!response.ok) {
        let value = (await response.json());
        if (typeof value !== "object") {
            // TODO sentry this
            value = {};
        }
        throw new RequestError(response.statusText, response.status, value, response.headers);
    }
    // Handles the case where T is void and the response is empty (e.g. for a DELETE request)
    if (response.status === 204) {
        return Promise.resolve(undefined);
    }
    if (responseType === "blob") {
        if (!response.blob) {
            throw new Error("Blob responses are not supported by the current fetcher implementation");
        }
        return (await response.blob());
    }
    return (await response.json());
}
